import React, { useContext } from 'react';
import FileProvider from '../../../providers/FileProvider';
import CompanyLogo from '../Logo/CompanyLogo';
import HeaderUserMenu from './HeaderUserMenu';
import { CompanyContext } from '../../../context/CompanyContext';
import HeaderPartnerMenu from './HeaderPartnerMenu';
import { CompanyConnectionContext } from '../../../context/CompanyConnectionContext';
import { CompanyConnectionState } from '../../../types/companyConnection/companyConnection';
import { CompanyRoleAssignmentContext } from '../../../context/CompanyRoleAssignmentContext';
import { UserContext } from '../../../context/UserContext';

export default function Header() {
  const { currentUser } = useContext(UserContext);
  const { currentCompany } = useContext(CompanyContext);
  const { companyConnections } = useContext(CompanyConnectionContext);
  const { companyRoles } = useContext(CompanyRoleAssignmentContext);

  const hasConnections = Array.from(companyConnections.values()).some(
    cc =>
      cc.state === CompanyConnectionState.active &&
      cc.companyId === currentCompany.companyId &&
      companyRoles.get(currentUser?.id || '')?.filter(cr => cr.companyId === cc.parentId).length,
  );

  const isPartner = currentCompany.partner || hasConnections;

  return (
    <>
      <header
        className={`relative flex h-[56px] min-h-[56px] w-full items-center border-b border-gray-default bg-header text-on-header`}
      >
        <div className='flex flex-grow items-center justify-between px-8'>
          <FileProvider>
            <div className='flex'>
              <div className='w-[220px] py-2'>
                <div className='flex max-h-10 max-w-[200px] items-center'>
                  <CompanyLogo />
                </div>
              </div>
              {isPartner ? (
                <div>
                  <HeaderPartnerMenu />
                </div>
              ) : null}
            </div>
            <div className='py-2'>
              <HeaderUserMenu />
            </div>
          </FileProvider>
        </div>
      </header>
    </>
  );
}
